export default __webpack_public_path__ + "static/media/QRIcon.744371f6.svg";